export const actions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
    SET_HEADLINE: 'SET_HEADLINE',
    SET_SUB_HEADLINE: 'SET_SUB_HEADLINE',
    SET_FOOTER_TEXT: 'SET_FOOTER_TEXT',
    SET_FOOTER_CLOSE_TEXT: 'SET_FOOTER_CLOSE_TEXT',
};
